export default __webpack_public_path__ + "static/media/Nosotros-GrupoIDT.9094f739.jpg";